import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './app/App';
import './styles/index.css';
import { bootstrapDemoModeFromUrl } from './lib/demo/demoMode';

// Procesa `?demo=1|0` PRE-React mount. Setea localStorage y limpia el
// query param de la URL antes de que cualquier componente lea
// isDemoMode(). Sin params, el flag persiste como estaba.
bootstrapDemoModeFromUrl();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('No se encontró el elemento #root en el HTML');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>
);
